import React from 'react';
import { Container } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './SafetyGridSkeleton.css'

function SafetyGridSkeleton() {
  return (
    <Container>
      <div className={s.safetyGridSkeletonContainer}>
        <div className={s.safetyGridSkeletonWrapper}>
          <div className={s.safetyGridSkeletonImgContainer}>
            <Skeleton className={s.safetyGridSkeletonImg} />
          </div>
          <div>
            <Skeleton className={s.safetyGridSkeletonHeading} />
            <Skeleton className={s.safetyGridSkeletonContent} />
            <div className={s.safetyGridSkeletonBtnGrp}>
              <Skeleton className={s.safetyGridSkeletonBtn} />
              <Skeleton className={s.safetyGridSkeletonBtn} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default withStyles(s)(SafetyGridSkeleton);
